import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe, SlicePipe } from '@angular/common';
import { MatDatepickerInputEvent, MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { AppViewService } from '../../shared';
import { AdminService } from '../../shared/services/admin.service';
import { SharedAuthService } from '../../shared/shared.auth.service';
import { take } from 'rxjs/operators';
import { RouterLink } from '@angular/router';
import { LoaderComponent } from '../../shared/elements/loader/loader.component';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { UserAccessSearchComponent } from '../user-access-search/user-access-search.component';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatSuffix, MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { LookupEditorComponent } from '../lookup-editor/lookup-editor.component';
import { ReportManagementComponent } from '../report-management/report-management.component';
import { BulkTemplatesComponent } from '../bulk-templates/bulk-templates.component';
@Component({
    selector: 'app-job-scheduling',
    templateUrl: './job-scheduling.component.html',
    styleUrls: ['./job-scheduling.component.scss'],
    imports: [RouterLink, LoaderComponent, MatTabGroup, MatTab, UserAccessSearchComponent, MatIcon, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFormField, MatLabel, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatSelect, FormsModule, MatOption, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, LookupEditorComponent, ReportManagementComponent, BulkTemplatesComponent, SlicePipe, DatePipe]
})
export class JobSchedulingComponent implements OnInit {
  Activetab = 0;
  ActionNA = '-NA-';
  invalidEndpointMessage = 'This is an UDLP trigger and cannot be triggered from the UI.';
  startDate = new Date(1990, 0, 1);
  selecteddate: any;
  fdisplayedColumns: string[] = ['jobName', 'jobType', 'refreshTime', 'triggeredby', 'Schedule', 'Params', 'Action'];
  sdisplayedColumns: string[] = ['jobName', 'jobType', 'refreshTime', 'triggeredby', 'Schedule', 'Params', 'Action'];
  expandedDetailColumns: string[] = ['expandedDetail'];
  expandedFailedJob: any;
  expandedSuccessJob: any;
  S_dataSource: MatTableDataSource<any>;
  F_dataSource: MatTableDataSource<any>;
  dateArray = [];
  selectedIndex = [];
  environment: string = 'steak-0';
  selectedOption = 'steak-0';
  dataSourceAdmin: MatTableDataSource<any>;
  displayedColumnsAdmin: string[] = [
    'User_Name',
    'Msid',
    'Justification',
    'Page',
    'Tab',
    'Request_Type',
    'Createdate',
    'Request_Status',
    'Action'
  ];
  showLoader: boolean = false;
  maxDate = new Date();
  data: any = [];
  mySelect = '1';
  selectedYear: any;
  selectedTable: any = '';
  reclassifyView: boolean = false;
  isAdmin: any = false;
  displayedColumnsMonthlyJobs: string[] = [
    'Environment',
    'Process_Level',
    'Process_Name',
    'Year',
    'Month',
    'Start_Time',
    'End_Time',
    'status'
  ];
  dataSourceMonthlyJobs: MatTableDataSource<any>;
  dataSourceErrorLogJobs: MatTableDataSource<any>;
  MonthlyJobsdata: any = [];
  errorData: any = [];
  lookupTables: any = [];
  hasUserRoleChangeAccess: boolean = false;
  isScheduledRefreshJobsExpanded: boolean = true;
  isFailedJobsExpanded: boolean = true;
  isSuccessJobsExpanded: boolean = true;
  isCostRefreshJobsExpanded: boolean = true;
  endPointRefreshGetVar: any;
  endPointRefreshPostVar: any;
  updateUserRoleVar: any;
  updateUserErrorVar: any;
  updateTechopsAdminVar: any;
  msid: any;
  disableTrigger = false;
  currentRefreshDateTime: any;
  pageSize: any;
  showHoursMessage: boolean = false;
  userMsid: string;
  userRoles: any[] = [];
  secureGroups: any[] = [];
  selectedUserRoleType: string;
  selectedSecureGroupType: any[];
  hasReportAdminAccess: boolean = false;
  hasReportWfAccess: boolean = false;
  yearValues = [
    {
      id: 1,
      name: new Date().getFullYear() - 1
    },
    {
      id: 2,
      name: new Date().getFullYear() - 2
    },
    {
      id: 3,
      name: new Date().getFullYear() - 3
    },
    {
      id: 4,
      name: new Date().getFullYear() - 4
    }
  ];
  tableName = [
    {
      id: 1,
      name: '[dbo].[NEDD_Daily]'
    },
    {
      id: 2,
      name: '[dbo].[Capital_Demand_UCMG_Data_Daily]'
    },
    {
      id: 3,
      name: '[dbo].[App_CBA_Service_Daily]'
    },
    {
      id: 4,
      name: '[dbo].[TL_Technology_PADU]'
    },
    {
      id: 5,
      name: '[dbo].[TL_technology]'
    }
  ];
  public filterby: any = [
    { name: 'Technical Owner', value: 'techonwer' },
    { name: 'SLO Owner', value: 'sloonwer' },
    { name: 'Group', value: 'groupby' }
  ];

  hasAccess: any = false;
   // Controls visibility of Bulk Templates tab based on user permissions
  hasBulkTemplatesAccess: any = false;

  @ViewChild('paginatorAdmin') paginatorAdmin: MatPaginator;
  adminData: any = [];
  scount: any;
  fcount: any;
  constructor(
    private appViewService: AppViewService,
    public admnsrv: AdminService,
    public toaster: ToastrService,
    private cRef: ChangeDetectorRef,
    private readonly datePipe: DatePipe,
    private sharedAuthService: SharedAuthService // Inject DatePipe here
  ) {
    this.userMsid = this.sharedAuthService.getMsid();
    this.isAdmin = this.sharedAuthService.checkAdminSGAccess();
  }

  ngOnInit(): void {
    if (!sessionStorage.getItem('techaccessData')) {
      this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
        this.getAccess();
      });
    } else {
       this.getAccess();
    }
    this.getUserRoles();
    this.getJobDetails();
    this.getMonthlyJobDetails();
    this.getAdminTable();
    this.getLookupTableName();
  }
  getUserRoles() {
    this.admnsrv.getUserRolesService(this.userMsid).subscribe(data => {
      this.userRoles = data['AllSecureRole']['Role'].split(',');
      this.secureGroups = data['AllSecureRole']['Secure_group_access'];
      if (this.secureGroups) this.secureGroups = data['AllSecureRole']['Secure_group_access'].split(',');
      this.selectedUserRoleType = data['userRole']?.['Role'] ? data['userRole']['Role'] : 'User';
      if (data['userRole']['Secure_group_access'])
        this.selectedSecureGroupType = data['userRole']['Secure_group_access'].split(',');
    });
  }
  updateUserRole() {
    let isDeleted;
    if (this.selectedUserRoleType == 'Admin') {
      isDeleted = '0';
    } else {
      isDeleted = '1';
    }
    const body = {
      IsDeleted: isDeleted,
      Secure_group_access: this.selectedSecureGroupType.join(','),
      Role: this.selectedUserRoleType,

    };
    this.admnsrv.updateUserRole(this.userMsid, this.selectedUserRoleType, body).subscribe(
      data => {
        this.updateUserRoleVar = data;
        this.toaster.success('Successfully updated User Role', '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      },
      error => {
        this.updateUserErrorVar = error;
        this.toaster.error(`Something went wrong`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
      }
    );
  }
  secureGroupChange(event) {
    this.selectedSecureGroupType = event.value;
  }
  getLookupTableName() {
    this.lookupTables = [
      { name: 'Work Queue Master Table', id: 'WQ_MSTR' },
      { name: 'App Attribute Table', id: 'APP_ATTR' },
      { name: 'Lookup Table with no Hierarchy', id: 'LOOKUP_NO_HRY' },
      { name: 'Lookup Table with 1 Hierarchy', id: 'LOOKUP_WITH_HRY' },
      { name: 'UI Dynamic Content Table', id: 'UI_DYNAMIC_CONTENT_TABLE' },
      { name: 'Video Library Table', id: 'VIDEO_LIBRARY_TABLE' }
    ];
  }

  getAccess() {
      this.isAdmin = this.sharedAuthService.checkAdminSGAccess();
      this.hasAccess = this.sharedAuthService.getTohPageAccessDetails('admin-dashboard','DashboardManager','edit');
      this.hasUserRoleChangeAccess =this.sharedAuthService.getTohPageAccessDetails('UserAccessManagement','AccessManager','edit');
      this.hasReportAdminAccess = this.sharedAuthService.getTohPageAccessDetails('report_admin',null,'edit');
      this.hasReportWfAccess = this.sharedAuthService.getTohPageAccessDetails('report_wf_edit',null,'edit');
      this.hasBulkTemplatesAccess = this.sharedAuthService.getTohPageAccessDetails('BulkTemplates','BulkTemplateManager','edit');
  }

  getDropDownText(id, object) {
    const selObj = _.filter(object, function(o) {
      return _.includes(id, o.id);
    });
    return selObj;
  }
  getJobDetails() {
    this.admnsrv.getJobDetls().subscribe((data: any) => {
      this.data = data;
      this.data.success = this.prepareRefreshJobs(this.data.success);
      this.data.failed = this.prepareRefreshJobs(this.data.failed);
      this.S_dataSource = new MatTableDataSource(this.data.success);
      this.scount = this.data.success.length;
      this.F_dataSource = new MatTableDataSource(this.data.failed);
      this.fcount = this.data.failed.length;
    });
  }

  getMonthlyJobDetails() {
    this.admnsrv.getMonthlyJobDetls().subscribe((jobs: any) => {
      this.MonthlyJobsdata = jobs;
      this.dataSourceMonthlyJobs = new MatTableDataSource(this.MonthlyJobsdata);
    });
  }

  showJobLoader = false;
  submit(app, index, $event) {
    $event.stopPropagation();
    this.cRef.detectChanges();
    const obj = {
      createdById: this.sharedAuthService.getMsid(),
      createdByName: JSON.parse(sessionStorage.getItem('currentUser')) || sessionStorage.getItem('currentUser')
    };
    if (app.type == 'AIDE_data') {
      obj['refreshDate'] = this.updatedate(this.dateArray['AIDE_data']);
    }
    if (app.type == 'TechLandscape') {
      obj['selectFields'] = {
        SelectFields:
          'product_id,name,description,oss,logo,market,homepage_url,organization,collaboration_url,additional_info_url,repo_url,jurisdiction,dataviability,alias,license,landscape,environment,padu'
      };
    }
    if (app.type == 'EP_FEED') {
      obj['refreshDate'] = this.updatedate(this.dateArray['EP_FEED']);
    }
    if (app.type == 'NDD_data') {
      obj['year'] = this.dateArray['NDD_data'];
    }
    if (app.type == 'Importer_Refresh') {
      obj['table'] = this.selectedTable;
    }
    this.handleEndPointRefresh(obj, index, false);
  }
  submit_error(app, index, $event) {
    $event.stopPropagation();
    this.cRef.detectChanges();
    const obj = {
      createdById: this.sharedAuthService.getMsid(),
      createdByName: JSON.parse(sessionStorage.getItem('currentUser')) || sessionStorage.getItem('currentUser')
    };
    if (app.type == 'AIDE_data') {
      obj['refreshDate'] = this.updatedate(this.dateArray['AIDE_data']);
    }
    if (app.type == 'TechLandscape') {
      obj['selectFields'] = {
        SelectFields:
          'product_id,name,description,oss,logo,market,homepage_url,organization,collaboration_url,additional_info_url,repo_url,jurisdiction,dataviability,alias,license,landscape,environment,padu'
      };
    }
    if (app.type == 'EP_FEED') {
      obj['refreshDate'] = this.updatedate(this.dateArray['EP_FEED']);
    }
    if (app.type == 'NDD_data') {
      obj['year'] = this.dateArray['NDD_data'];
    }
    if (app.type == 'Importer_Refresh') {
      obj['table'] = this.selectedTable;
    }
    this.handleEndPointRefresh(obj, index, true);
  }
  checkParamType(app, param) {
    if (app) {
      if (app['Params']?.includes(param.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    }
  }

  prepareRefreshJobs(jobs: any[] = []) {
    return jobs.map(job => ({
      ...job,
      Params: typeof job.Params === 'string' ? job.Params.toLowerCase().split(',') : job.Params || []
    }));
  }

  getLastRefreshDate(app) {
    return app?.Startdate || app?.refreshTime;
  }

  toggleFailedJob(app) {
    this.expandedFailedJob = this.expandedFailedJob === app ? null : app;
  }

  toggleSuccessJob(app) {
    this.expandedSuccessJob = this.expandedSuccessJob === app ? null : app;
  }
  stopjobLoader() {
    this.showJobLoader = false;
    this.cRef.detectChanges();
  }
  selectChange(app,index) {
    this.selectedIndex.push(index);
    this.dateArray[app.type] = this.yearValues[index]['name'];
    this.disableTrigger = false;
  }
  tableNameChange(index) {
    this.selectedIndex.push(index);
    this.disableTrigger = false;
  }

  private handleEndPointRefresh(body: any, index: number, isError: boolean): void {
    const dataSource = isError ? this.F_dataSource : this.S_dataSource;
    const job = dataSource.data[index];
    const url = job['Endpoint'];
    if (this.isAdbTrigger(job)) {
      return;
    }
    const method = job['API_Method'].toLowerCase();
    this.disableTrigger = true;
    const request =
      method === 'get' ? this.admnsrv.endPointRefreshGet(url, body) : this.admnsrv.endPointRefreshPost(url, body);
    request.subscribe(
      () => {
        this.getJobDetails();
        this.disableTrigger = false;
        this.toaster.success(`Successfully updated on ${this.maxDate}`, '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      },
      error => {
        this.getJobDetails();
        this.disableTrigger = false;
        this.toaster.error(`Something went wrong`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
        console.log(error);
      }
    );
  }
  isAdbTrigger(app: any): boolean {
    return typeof app?.triggeredbyid === 'string' && app.triggeredbyid.includes('ADB');
  }
  addDateEvent(event: MatDatepickerInputEvent<Date>, app, index) {
    this.selectedIndex.push(index);
    this.dateArray[app.type] = event.value;
    if (app.type == 'EP_FEED') {
      const diffInMs = Date.parse(new Date().toISOString()) - Date.parse(this.dateArray['EP_FEED']);
      const diffInHours = diffInMs / 1000 / 60 / 60;
      if (diffInHours > 72) {
        this.showHoursMessage = true;
        this.disableTrigger = true;
      } else {
        this.showHoursMessage = false;
        this.disableTrigger = false;
      }
    } else this.disableTrigger = false;
  }
  updatedate(date) {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  getAdminTable() {
    this.appViewService.getTechopsDevAdminPage().subscribe(res => {
      this.adminData = res;
      this.dataSourceAdmin = new MatTableDataSource(this.adminData);
      this.dataSourceAdmin.paginator = this.paginatorAdmin;
    });
  }

  status(value, app) {
    const data = {
      Request_Status: value,
      Updatedate: new Date(),
      page: app.Page
    };

    this.appViewService.updateTechopsAdminTable(data, app.Msid, app.Request_Type).subscribe(res => {
      if (value === 'Approved') {
        this.updateTechopsAdminVar = res;
        this.msid = this.sharedAuthService.getMsid();
      }
      this.getAdminTable();
    });
  }

  MonthlyJobFilter(filterName: string) {
    this.dataSourceMonthlyJobs.filter = filterName.trim().toLowerCase();
  }
  splitCommaSeparatedValue(value) {
    if (value === null || value === undefined || value === '') {
      return [''];
    }
    return value
      .toString()
      .split(',')
      .map(item => item.trim());
  }
  breakWord(value) {
    return value?.split(',')?.join(', ');
  }
}
